import React from 'react';
import { FaCalendarPlus, FaTwitter, FaPenNib, FaSplotch } from 'react-icons/fa';
import { Nav, Navbar} from 'react-bootstrap';

class NavBar extends React.Component {

  render() {
    return (
      <Navbar bg="light" expand="lg">
        <Navbar.Brand>XANDA SCHOFIELD</Navbar.Brand>
        <Navbar.Toggle aria-controls="all-nav-items" />
        <Navbar.Collapse id="all-nav-items">
          <FaSplotch /> 
          <Nav className="mr-auto" defaultActiveKey={this.props.activeKey}>
            <Nav.Item>
              <Nav.Link eventKey="home" href="#/home">Home</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="about" href="#/about">About Me</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="research" href="#/research">Research</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="teaching" href="#/teaching">Teaching</Nav.Link>
            </Nav.Item>
          </Nav>
          <Nav className="justify-content-right">
            <Nav.Item>
              <Nav.Link eventKey="CV" href="./files/cv.pdf"><FaPenNib /> CV</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Book Meeting" href="https://calendly.com/profxanda"><FaCalendarPlus /> Meetings</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Twitter" href="https://twitter.com/XandaSchofield"><FaTwitter /> Twitter</Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default NavBar;
